import 'masonry-layout';


// WEBPACK FOOTER //
// ./scripts/autoload/_masonry.js